import { defineComponent as _defineComponent } from 'vue'

import { useI18n } from "vue-i18n-bridge";
import { NolaPfMicroCmsContest } from "@/lib/models/nolaPfContest";
import LoadingSpinner from "@/components/atoms/LoadingSpinner.vue";
import ContestEntryFormContestAside from "@/components/organisms/event/ContestEntryFormContestAside.vue";
import ContestEntryFormStepper from "@/components/organisms/event/ContestEntryFormStepper.vue";
import IconChevronLeft from "~icons/figma/ChevronLeft";


export default /*#__PURE__*/_defineComponent({
  __name: 'ContestEntryFormLayout',
  props: {
    loadState: { type: String, required: true },
    errorMessage: { type: String, required: true },
    currentStep: { type: Number, required: true },
    title: { type: String, required: true },
    description: { type: String, required: false },
    contest: { type: null, required: true }
  },
  setup(__props: any) {



const { t } = useI18n();

return { __sfc: true,t, LoadingSpinner, ContestEntryFormContestAside, ContestEntryFormStepper, IconChevronLeft }
}

})